import { render, staticRenderFns } from "./EthnicBackgroundTemplate.vue?vue&type=template&id=a340411e"
import script from "./EthnicBackgroundTemplate.vue?vue&type=script&lang=js"
export * from "./EthnicBackgroundTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports